import React from 'react';
import styled from 'styled-components';
import variables from '@ingka/variables/design-tokens';
import cssIngka from '@ingka/variables/colours-css';

interface ItemProps {
  imgSrc: string;
  captionId: string;
}
const StyledItem = styled.li`
  padding: 1px;
  background: ${cssIngka.colourNeutral2};
  @media (min-width: ${variables.breakpointM}) {
    width: 275px;
  }
`;
const StyledImage = styled.img`
  width: 100%;
`;
const StyledDetails = styled.div`
  padding: 20px;
  img {
    margin-bottom: 14px;
    display: block;
  }
`;
export const OnboardingItem: React.FC<ItemProps> = ({
  children,
  imgSrc,
  captionId,
}): JSX.Element => {
  return (
    <StyledItem aria-describedby={captionId}>
      <StyledImage src={imgSrc} role="presentation" width={273} />
      <StyledDetails>{children}</StyledDetails>
    </StyledItem>
  );
};
